// NOTE do we need this for anything?
// calling javascript on tags...
// can be called from unexpected places!

$each($all('form input, form textarea'), el => $e(el, 'focus', function() {
	const label = el.parentNode.querySelector('label')
	if (label)
		label.classList.add('active');
}));

$each($all('form input, form textarea'), el => $e(el, 'blur', function() {
	if (el.value.length === 0) {
		const label = el.parentNode.querySelector('label')
		if (label)
			label.classList.remove('active');
	}
}));
